import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

import { engagementCanvasStep } from "../get";

export const engagementCanvasStepCacheKeys: AllRouteEndpoints[] = [engagementCanvasStep];
